<header>
  <div class="sign-out-header">
    <img src="assets/images/app-logo-for-school.svg" alt="入試正解デジタル for School" />
  </div>
</header>
